import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-product-model-popup',
  templateUrl: './add-product-model-popup.component.html',
  styleUrls: ['./add-product-model-popup.component.css']
})
export class AddProductModelPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
